"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPublicOrganization = exports.getPublicOrganizations = exports.putOrganizationAccessibility = exports.deleteOrganizationPermission = exports.postOrganizationPermission = exports.putOrganizationAction = exports.delOrganizations = exports.postOrganization = exports.putOrganization = exports.getOrganization = exports.getOrganizations = void 0;

var common_1 = require("../common");

var root_1 = require("./root");

var organizationsAuthorizedPath = root_1.organizationManagementAuthorized + '/organizations/';
var organizationsPublicPath = root_1.organizationManagementPublic + '/organizations/';

var getOrganizations = function getOrganizations(authentication, queryParameters) {
  return common_1.get(authentication, organizationsAuthorizedPath, queryParameters);
};

exports.getOrganizations = getOrganizations;

var getOrganization = function getOrganization(authentication, id) {
  return common_1.get(authentication, organizationsAuthorizedPath + id);
};

exports.getOrganization = getOrganization;

var putOrganization = function putOrganization(authentication, organization) {
  return common_1.put(authentication, organizationsAuthorizedPath + organization.id, organization);
};

exports.putOrganization = putOrganization;

var postOrganization = function postOrganization(authentication, organization) {
  return common_1.post(authentication, organizationsAuthorizedPath, organization);
};

exports.postOrganization = postOrganization;

var delOrganizations = function delOrganizations(authentication, id) {
  return common_1.del(authentication, organizationsAuthorizedPath + id);
};

exports.delOrganizations = delOrganizations;

var putOrganizationAction = function putOrganizationAction(authentication, id, action, data) {
  return common_1.putSub(authentication, organizationsAuthorizedPath, id, action, data);
};

exports.putOrganizationAction = putOrganizationAction;

var postOrganizationPermission = function postOrganizationPermission(authentication, id, permission) {
  return common_1.postPermission(authentication, organizationsAuthorizedPath, id, permission);
};

exports.postOrganizationPermission = postOrganizationPermission;

var deleteOrganizationPermission = function deleteOrganizationPermission(authentication, id, permissionId) {
  return common_1.deletePermission(authentication, organizationsAuthorizedPath, id, permissionId);
};

exports.deleteOrganizationPermission = deleteOrganizationPermission;

var putOrganizationAccessibility = function putOrganizationAccessibility(authentication, id, accessibility) {
  return common_1.putAccessibility(authentication, organizationsAuthorizedPath, id, accessibility);
};

exports.putOrganizationAccessibility = putOrganizationAccessibility;

var getPublicOrganizations = function getPublicOrganizations(authentication, queryParameters) {
  return common_1.get(authentication, organizationsPublicPath, queryParameters);
};

exports.getPublicOrganizations = getPublicOrganizations;

var getPublicOrganization = function getPublicOrganization(authentication, id) {
  return common_1.get(authentication, organizationsPublicPath + id);
};

exports.getPublicOrganization = getPublicOrganization;